import { offsetTop } from './dom.js'

/**
 * @param {HTMLElement|null} element
 * @param {HTMLElement|Window} parent
 */
export function scrollTo(element, parent = window) {
    if (element === null) {
        return
    }
    const elementOffset = offsetTop(element, parent)
    console.log(elementOffset)
    let top = elementOffset
    parent.scrollTo({
        top,
        left: 0,
        behavior: 'smooth',
    })
}
